import { IPositionPlatformRuleDictionaryApi } from '@/types';

export class PositionPlatformRuleDictionaryItem {
    agentPositionCap: number;
    companyPositionCap: number;
    id: number;
    name: string;

    constructor(data: IPositionPlatformRuleDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.companyPositionCap = data.company_position_cap;
        this.agentPositionCap = data.agent_position_cap;
    }
}
